import DifyOrderDTO from './DifyOrderDTO';
import { getLocalizedText } from '@vp-dst/localization-util';

export default class DifyOrderUpdateDTO extends DifyOrderDTO {
    constructor({ productName, productPfid, productConfigurations, note, uploads, uploadRefs, difyServiceQuantity, itemId, multiselectedProducts }) {
        super({
            productName,
            productPfid,
            productConfigurations,
            note,
            uploads,
            uploadRefs,
            difyServiceQuantity,
            multiselectedProducts
        });

        this.ItemId = itemId;
        
        this.validate = this.validate.bind(this);
    }

    validate() {
        if (!this.SelectedProduct || !this.SelectedProduct.Name) {
            return getLocalizedText('please-select-a-product-before-continuing');
        }
    
        const brief = this.Brief;
        if (!brief.Notes || brief.Notes.length === 0) {
            return getLocalizedText('please-describe-your-design-idea');
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/designServices/dtos/DifyOrderUpdateDTO.js